import { PATIENT_VERIFICATION_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from './subsections/patient-verification/questionnaireAnswer'
import { HISTORY_AND_DIAGNOSES_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from './subsections/history-and-diagnoses/questionnaireAnswer'

export const PATIENT_BACKGROUND_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  ...PATIENT_VERIFICATION_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...HISTORY_AND_DIAGNOSES_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE
}
